import {
    YEAR_GROUP_SELECTED,
    ITEM_TYPE_SELECTED,
    ITEM_CATEGORY_SELECTED,
    COUNTRY_SPEC_LOAD_SUCCESS,
    CLEAR_SELECTION
} from './filter-actions';

const generateInitialState = (spec) => {
    // Abbreviated year names, for library year filters.
    // Need to explicitly specify this way, rather than with a variable year number,
    // so they don't get marked as "obsolete" in locale/*/messages.json files
    // todo: check that the locale is set at this point
    const yearGroups = spec.series.map(yg => ({
        id: yg.id,
        name: yg.name,
        checked: false
    }));

    const itemTypes = [];
    spec.itemTypes.map(itemType => itemTypes.push({
        id: itemType.id,
        name: itemType.title,
        checked: false
    }));

    const itemCategory = [];
    spec.itemCategories.map(category => itemCategory.push({
        id: category.id,
        name: category.title,
        checked: false
    }));

    return {
        yearGroups,
        itemTypes,
        itemCategories: itemCategory,
        clearButtonDisabled: true,
        goButtonDisabled: true
    };
};

export default (state = {}, action) => {
    let updatedItemTypes = [];
    let updatedYearGroups = [];
    let updatedCategories = [];

    switch (action.type) {
        case COUNTRY_SPEC_LOAD_SUCCESS: {
            const initialState = generateInitialState(action.value);

            return Object.assign({}, state, {
                yearGroups: initialState.yearGroups,
                itemTypes: initialState.itemTypes,
                itemCategories: initialState.itemCategories,
                countrySpec: action.value,
                clearButtonDisabled: initialState.clearButtonDisabled,
                goButtonDisabled: initialState.goButtonDisabled
            });
        }

        case YEAR_GROUP_SELECTED: {
            updatedYearGroups = state.yearGroups.map((yearGroup) => {
                if (yearGroup.id === parseInt(action.yearGroupId, 10)) {
                    return Object.assign({}, yearGroup, {
                        checked: action.checked
                    });
                }
                return yearGroup;
            });

            return Object.assign({}, state, {
                yearGroups: updatedYearGroups
            });
        }

        case ITEM_CATEGORY_SELECTED: {
            updatedCategories = state.itemCategories.map((category) => {
                if (category.id === parseInt(action.itemCategoryId, 10)) {
                    return Object.assign({}, category, {
                        checked: action.checked
                    });
                }
                return category;
            });

            return Object.assign({}, state, {
                itemCategories: updatedCategories
            });
        }

        case ITEM_TYPE_SELECTED: {
            updatedItemTypes = state.itemTypes.map((itemType) => {
                if (itemType.id === parseInt(action.itemTypeId, 10)) {
                    return Object.assign({}, itemType, {
                        checked: action.checked
                    });
                }
                return itemType;
            });

            return Object.assign({}, state, {
                itemTypes: updatedItemTypes
            });
        }

        case CLEAR_SELECTION: {
            updatedYearGroups = state.yearGroups.map(yearGroup => Object.assign({}, yearGroup, {
                checked: false
            }));

            updatedItemTypes = state.itemTypes.map(itemType => Object.assign({}, itemType, {
                checked: false
            }));

            updatedCategories = state.itemCategories.map(category => Object.assign({}, category, {
                checked: false
            }));

            return Object.assign({}, state, {
                yearGroups: updatedYearGroups,
                itemTypes: updatedItemTypes,
                itemCategories: updatedCategories
            });
        }

        default:
            return state;
    }
};

export function countrySpecLoadFailed(state = false, action) {
    switch (action.type) {
        case 'COUNTRY_SPEC_LOAD_ERROR':
            return action.hasError;

        default:
            return state;
    }
}

export function countrySpecLoading(state = false, action) {
    switch (action.type) {
        case 'COUNTRY_SPEC_LOADING':
            return action.isLoading;

        default:
            return state;
    }
}

export function countrySpec(state = {}, action) {
    switch (action.type) {
        case 'COUNTRY_SPEC_LOAD_SUCCESS':
            return action.value;

        default:
            return state;
    }
}

